import { tablelist } from "../components/funtionsBD/Mainservice";
import { normalizeSessionTables } from "./coachSessionTables";

/** @type {Map<string, Promise<unknown[]>>} */
const inflightByKey = new Map();

export function sessionTableCacheKey(grId, tsId, teId) {
  return `${grId}:${tsId}:${teId}`;
}

/**
 * Dedupe concurrent groupTable requests for the same session exercise.
 * @returns {Promise<object[]>} normalized table rows
 */
export async function fetchSessionTablesDeduped({ gr_id, ts_id, te_id }) {
  if (!gr_id || !ts_id || !te_id) return [];

  const key = sessionTableCacheKey(gr_id, ts_id, te_id);
  const existing = inflightByKey.get(key);
  if (existing) return existing;

  const run = tablelist({ gr_id, ts_id, te_id })
    .then((res) => normalizeSessionTables(res?.data?.data || []))
    .finally(() => {
      inflightByKey.delete(key);
    });

  inflightByKey.set(key, run);
  return run;
}
